import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import nissan from "./../../../../assets/info/x-trail-hero.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const NissanXTrail = () => {
  useSmallNav("Nissan X-Trail");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan X-Trail"} bolder />
        <InfoHero image={nissan} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={"Chcesz mieć większy prześwit w swoim Nissanie X-Trail?"}
            />
            <InfoHeader text={"Możemy Ci pomóc!"} />
            <p>
              Zawieszenie Pedders oferuje wszystko, czego potrzebujesz, aby
              podnieść swojego X-Trail. Nasz zestaw do podnoszenia zawiera
              cztery sprężyny Pedders TrakRyder i cztery amortyzatory TrakRyder,
              a także zestaw śrub do regulacji pochylenia kół (tylko model T30).
              Nie wiesz, czy to właściwy zestaw? Poniżej wymieniono niektóre,
              typowe pytania dotyczące naszego zestawu.
            </p>
            <InfoHeader
              text={"O ile zestaw podniesie mojego X-Traila?"}
              size="smaller"
            />
            <p>
              Pedders stara się unikać podawania wartości “liftu”, a raczej
              podajemy wysokość montowanych elementów. Dlaczego? Ponieważ
              sprężyny osiadają z upływem czasu, w zależności od przebiegu, czy
              często przewożonych ciężarów, itp. Nasze zestawy mogą podnieść np.
              o 1 cal, ale jeśli Twój samochód jest już o cal niższy niż jak był
              nowy, oznaczałoby to 2 cale z zamontowanymi nowymi sprężynami.
            </p>
            <p>
              Tak więc, odpowiadając na pytanie, wysokość montażowa naszego
              zestawu to 710 mm z przodu, 715 mm z tyłu (przy kołach
              16-calowych) dla modeli T30 (2001-2007) i 695 mm z przodu, 705 mm
              z tyłu (przy kołach 17 calowych) dla modeli T31 (od 2007 r.).
              Mierzy się ją od dolnego rantu felgi do krawędzi nadkola.
            </p>
            <InfoHeader
              text={"Słyszałem, że nie można podwyższyć X-Trail?"}
              size="smaller"
            />
            <p>
              Istnieją ograniczenia w możliwościach podwyższenia X-Trail.
              Czynnikiem ograniczającym jest kąt pracy przegubu (CV - shaft).
              Jeśli podniesiesz pojazd zbyt wysoko, spowodujesz, że przeguby
              wyjdą poza ich zakres pracy. Powoduje to trwałe ich uszkodzenie i
              możliwe uszkodzenia innych elementów. Pedders wziął to pod uwagę
              podczas projektowania i definiowania ostatecznej wysokości montażu
              więc możesz być pewien, że to nie jest problemem.
            </p>
            <InfoHeader
              text={"Co to są śruby regulujące kąt pochylenia?"}
              size="smaller"
            />
            <p>
              Przy podnoszeniu, lub obniżaniu pojazdu, kąt pochylenia kół ulega
              zmianie. Jest to wielkość nachylenia górnej części koła do środka
              lub na zewnątrz. Nachylenie górnej krawędzi kołą do środka jest
              tak zwanym nachyleniem negatywnym, a na zewnątrz pozytywnym.
              Podnosząc X-Trail T30, prawdopodobne jest, że nachylenie będzie
              pozytywne i będzie wykraczać poza standardy Nissana. Ponieważ
              nachylenie nie jest standardowo regulowane w X-Trail T30, możemy
              dostarczyć zestaw śrub, które umożliwiają regulację, aby zapewnić
              zgodność kąta pochylenia koła ze standardami producenta. Z tego
              powodu zawsze zalecamy sprawdzenie geometrii kół po zamontowaniu
              zestawu Pedders lub dokonaniu jakichkolwiek innych zmian w
              zawieszeniu. Zestaw śrub do T30 to: 458014.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "X-Trail")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title="Nissan X-Trial"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title="Nissan X-Trial"
              width="100%"
              height="315"
              src="https://www.youtube.com/embed/-x9r6VqbGrg"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
      </Container>
    </section>
  );
};

export default NissanXTrail;
